import {saveCode} from "../code/CodeService";
import {saveServiceCode} from "../serviceCode/ServiceCodeService";
import {CacheType} from "../../constant/CodeSpecNum";
import {useCacheRefresh} from "../../hooks/useCacheRefresh";
import {isEmpty} from "../../components/commonmethod/CommonMethod";
import {createCustomCodeAtDrawer} from "../field/CustomCodeService";

export const useHandleApiSelect = () => {
    const refreshCache = useCacheRefresh();
    const handleApiSelect = async (entity, selectedId, rootCodeId, v, success, failure) => {

        if(isEmpty(v)) {
            alert("코드명을 입력해주세요");
            return
        }

        // 최상위 등록일 경우 parentKey
        const data = {
            parentId: selectedId,
            rootCodeId : rootCodeId,
            name: v,
            // 서비스에서 사용
            minimumLevel: "EXCELLENT",
            targetLevel: "EXCELLENT",
            // 커스텀코드 사용
            parent : {id : selectedId},
        }

        switch (entity) {
            case "code":
                await saveCode(data, success, failure).then(() => refreshCache(CacheType.code));
                break;
            case "serviceCode" :
                await saveServiceCode(data, success, failure).then(() => refreshCache(CacheType.serviceCode));
                break;
            case "customCode" :
                await createCustomCodeAtDrawer(data, success, failure).then(() => refreshCache(CacheType.customCode));
                break;
        }
    }

    return handleApiSelect;
}